import React from "react";
import { Accordion } from "../../../components/base/Accordion";
import { IMCPResponse } from "../../../libs/models/app/mcp/Tool";
import { Badge, IconButton, Textarea } from "../../../components/base";
import { showAlertToast } from "../../../redux/features/app/appSlice";
import { AlertType } from "../../../libs/models/AlertType";
import { useAppDispatch } from "../../../redux/app/hooks";

interface ChatHistoryToolResultProps {
  toolName: string,
  result: IMCPResponse
}

// 결과 표시/복사 시 JSON 이스케이프로 이중이 된 백슬래시(\\)를 \로 정규화 (윈도우 경로 복사 대응)
const unescapeBackslash = (text: string): string => text.replace(/\\\\/g, '\\');

export const ChatHistoryToolResult: React.FC<ChatHistoryToolResultProps> = ({toolName, result}) => {
    const [openValues, setOpenValues] = React.useState<string[]>([])
    const dispatch = useAppDispatch();
    const responseText = result.content ? unescapeBackslash(result.content[0].text) : '';
    const requestText = result.arguments ? unescapeBackslash(JSON.stringify(result.arguments, null, 2)) : '';
    
    const onToggle = (openItems:string[]) => {
      setOpenValues(openItems);
      };
    const handleCopyClick = (text: string) => {
      
      const tempInput: HTMLTextAreaElement = document.createElement('textarea');
        tempInput.value = text;
        tempInput.style.position = 'fixed';
        tempInput.style.opacity = '0';
        document.body.appendChild(tempInput);
        tempInput.select();
        const successful = document.execCommand('copy');
        document.body.removeChild(tempInput);
        if (successful) {
          dispatch(showAlertToast({ altMessage: '복사되었습니다', altType: AlertType.Info }));
        } else {
          dispatch(showAlertToast({ altMessage: '복사 실패하였습니다. 다시 시도해주세요.', altType: AlertType.Info }));
        }
    };
      
      const Contents =(
        <div className="result-contents">
          {/* {results.content[0].text} */}
          {result.arguments && 
            <div className="contents-text">
              <div className="contents-header">
                <Badge className="keyword" size="large" accent="info" variant="tint">요청 </Badge>
                <div className="dsx-side-right"><IconButton name='copy' onClick={() => {handleCopyClick(requestText)}}>복사</IconButton></div>
              </div>
              <Textarea  variant="filled" value={requestText} maxRows={5} readOnly/>
            </div>
          }
          {result.content && 
            <div className="contents-text">
              <div className="contents-header">
                {/* <Text size='label2'>응답: </Text> */}
                <Badge className="keyword" size="large" accent="info" variant="tint">응답 </Badge>
                <div className="dsx-side-right"><IconButton name='copy' onClick={() => {handleCopyClick(responseText)}}>복사</IconButton></div>
              </div>
            <Textarea  variant="filled" value={responseText} rows={5} readOnly/>
            </div>
          }
        </div>
      );

      const Label = (
        <div className="card-label">
          <Badge accent='normal'>결과</Badge>
          <div className="tool-name">{toolName.split('__')[1] ?? toolName}</div>
        </div>
      );
      
    return(
      <div className="msg-content">
        <div className="tool-result">
          <div className="result-card">
              <Accordion
                  data={[{
                      content: Contents,
                      icon: '',
                      label: Label,
                      value: toolName,
                      }]}
                  isMultiple={true}
                  defaultValue={openValues}
                  onChange={onToggle}
          />
          </div>
        </div>
      </div>
    );
}